export async function normalizeScreenshotBmp(blob: Blob): Promise<Blob> {
	if (blob.type !== 'image/bmp' || blob.size < 54) return blob;
	const header = new DataView(await blob.slice(0, 54).arrayBuffer());
	const width = header.getInt32(18, true);
	const height = header.getInt32(22, true);
	const bits = header.getUint16(28, true);
	const stride = Math.ceil((width * bits) / 32) * 4;
	if (
		header.getUint16(0, true) !== 0x4d42 ||
		header.getUint32(14, true) !== 40 ||
		header.getUint16(26, true) !== 1 ||
		(bits !== 24 && bits !== 32) ||
		header.getUint32(30, true) !== 0 ||
		stride < 54 ||
		Math.abs(height) <= 1 ||
		header.getUint32(10, true) !== stride ||
		header.getUint32(2, true) !== blob.size + stride ||
		stride * Math.abs(height) !== blob.size
	)
		return blob;

	// RAGE can return a BMP one scanline short. Describe only the complete rows;
	// preserve their bytes and orientation instead of inventing the missing pixels.
	header.setUint32(2, blob.size, true);
	header.setInt32(22, height - Math.sign(height), true);
	header.setUint32(34, blob.size - stride, true);
	return new Blob([header.buffer, blob.slice(54)], { type: blob.type });
}
